import React from 'react';
import PropTypes from 'prop-types';
import { components } from 'react-select';
import { SearchIcon } from '@pattern-library/icon';
const SearchControl = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(components.Control, props, /*#__PURE__*/React.createElement(SearchIcon, {
    customSize: "18px",
    color: "gray"
  }), children);
};
SearchControl.propTypes = {
  children: PropTypes.node
};
export default SearchControl;